<script>
import {  mapGetters } from "vuex";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CreateSetup from '../customer/list/setup'
import contextmenu from '@/helpers/mixins/contextmenu' 
import Transaction from '../customer/list/transaction' 
import TechDetay from '../customer/modals/tech_detail'
import KurulumModal from '../customer/modals/kurulum_modal'
import MacModal from '../customer/modals/mac_modal'
import Loader from "@/components/widgets/loader.vue";

import Vue from 'vue';
import { notify } from '@/helpers/notify' 

export default {
  page: {
    title: "İş Listesi",
  },
  mixins: [ contextmenu],
  components: {
    Layout,
    PageHeader,
    CreateSetup,
    Transaction,
    TechDetay,
    KurulumModal,
    MacModal,
    Loader
  },
  computed: {
    ...mapGetters('authfack',['userdata']),
    dnow(){
      const now = new Date();
      return this.appoitmentFormat(now)
    }
  },
  data() {
    return {
      title: "İŞ LİSTESİ",
      items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "İŞ LİSTESİ",
          active: true,
        },
      ],
      url: "technic-service",
      techDetail:{},
      dataLoading:true,
      assignData: {},
      personelList:[],
      ilceList:[],
      userList:[],
      kurulumDetay:{},
      kurulumModalOpen:0,
      openTab:0,
      form:{ 
        appointment_at: null,
        user_id: null,
        quarter_id: null,
        assigned_userid: null
      },
      buttons:[
        { title:"İşleme Al", icon:'check', func:this.islemeAl, visible: [1,2,3,4]},
        { title:"Arıza Detay", icon:'check', func:this.arizaDetay, visible: [3]},
        { title:"İşleme Al", icon:'check', func:this.islemeAl, visible: [5]},
        { title:"Hata Detay", icon:'check', func:this.arizaDetay, visible: [5]},
      ],  
      columns: [
        {
          field: '#',
          sortable: false,
          thClass: 'width-50',
        },
        {
          label: 'Tip',
          field: this.type,
          html:true
        },  
        { 
          label: 'Kullanıcı Adı',
          field: "username",
        },
        {
          label: 'Randevu Tarihi',
          field: this.appointment,
          sortable:false,
        }, 
        {
          label: 'Randevuyu Açan',
          field: "user_name",
        }, 
        {
          label: 'İsim Soyisim',
          field: "fullname"
        },
        {
          label: 'Cep Telefonu',
          field: this.phonenumber,
          html: true,
          sortable: false,
        },
         {
          label: 'Whatsapp',
          field: this.whatsapp,
          html: true,
          sortable: false,
        },
        {
          label: 'İl',
          field: "district_name",
        }, 
        {
          label: 'Bölge',
          field:  "quarter_name",
        },
        {
          label: 'Adres',
          field:  "address",
          sortable: false,
        }, 
      ],
      update:0,
      data: {},
      transactionData:{},
      isLoading: true,
      rows: [],
      totalRecords: 0,
      datas:[],
      serverParams: {
        columnFilters: {},
        sort: [{ field: '', type: '' }],
        page: 1,
        perPage: 50,
      },
      currentPage: 0,
      selected: 0,
      pageLength: 0,
      paginationOptions: {
          enabled: true,
          dropdownAllowAll: false,
          perPage: 50,
          setCurrentPage: 1,
          perPageDropdownEnabled: false,
          perPageDropdown: [50, 100, 200],
          mode: 'records',
          position: 'top',
          nextLabel: '',
          prevLabel: '',
      },
      macModalOpen:1
    };
  },
  mounted() {
    this.getIlce().then(e=>{ this.ilceList = e })
    this.getUserList().then(e=>{ this.userList = e })
    this.today()

    this.updateParams({ columnFilters:{ ...this.form } })
    if(this.userdata.currentUser.role_name == 'admin' || this.userdata.currentUser.role_name == 'personel'){
      this.getUsers().then(data=>{
        let personelList = []
        data.map(e => {
          personelList.push({ id:e.id, name:e.name})
        })
        this.personelList = personelList
        this.columns.push(
          {
            label: 'Atanan',
            field: 'assigned_name',
            sortable: false,
          })
      });
      this.buttons.push({ title:"Düzenle",icon:'edit', func:this.edit, visible: [1,2,3,4]})
      this.buttons.push({ title:"Sil",icon:'trash', func:this.sil, visible: [1,2,3,4]})
    }
    this.loadItems()
  },
  methods: {
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    filter(){
      this.updateParams({ columnFilters:{ ...this.form } })
      this.loadItems()
    },
    appoitmentFormat(now){
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based
      const day = now.getDate().toString().padStart(2, '0');
      const hours = now.getHours().toString().padStart(2, '0');
      const formattedDateTime = `${year}-${month}-${day}T${hours}:00`;
      return formattedDateTime;
    },
    today(){
      const now = new Date();
      this.form.appointment_at = this.appoitmentFormat(now)
    },
    tomorrow(){
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);
      this.form.appointment_at = this.appoitmentFormat(tomorrow)

      this.filter()
    },
    nextday(){
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 2);
      this.form.appointment_at = this.appoitmentFormat(tomorrow)
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    
    loadItems() {
      this.dataLoading = true
      this.getFromServer(this.serverParams).then(response => {

        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
        this.dataLoading = false
      })
    },
    getFromServer() {
      return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            this.datas = res.data
            resolve({
              rows: res.data.data,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
            })
          })
          .catch(error => { reject(error) })
      })
    },
    type(obj){
      //1:kurulum 2:söküm 3:ariza 4:taşıma 5:keşif
      if(typeof obj == 'object')
        obj = obj.type_id

      let out = '';
      switch (obj) {
        case 1:
          out = '<label style="font-size:0.8rem;margin:0" class="badge bg-success">Kurulum</label>'
          break;
        case 2:
          out = '<label style="font-size:0.8rem;margin:0" class="badge bg-danger">Söküm</label>'
          break;
        case 3:
          out = '<label style="font-size:0.8rem;margin:0" class="badge bg-warning">Arıza</label>'
          break;
        case 4:
          out = '<label style="font-size:0.8rem;margin:0" class="badge bg-info">Taşıma</label>'
          break;
        case 5:
          out = '<label style="font-size:0.8rem;margin:0" class="badge bg-secondary">Hata Kaydı</label>'
          break;
      }
      return out 
    }, 
    async getUsers(){
      return await this.$http.get('/technic-service/listServicePersonel')
      .then(response =>  response.data.content)
    },
    async getIlce(){
      return await this.$http.post('/address/ilce')
      .then(response =>  response.data)
    },
    async getUserList(){
      return await this.$http.post('/users?output=one&fields=id,name')
      .then(response => response.data )
    },
    appointment(obj){
      return this.formatDate(obj.appointment_at, 'DD.MM.YYYY HH') + ':00'
    },
    phonenumber(obj){
      const url =   obj.phonenumber;
      return `<a href=tel:'${url}'  >${obj.phonenumber}</a>`
    },
    whatsapp(obj){
      const tel = obj.phonenumber2 ? obj.phonenumber2 : (obj.phonenumber ? obj.phonenumber : '-') 
      const url =  "https://wa.me/" + tel;
      return `<a target="_blank" href='${url}'  >${tel}</a>`
    },
    edit(props){
     
      this.data = { 
        id: props.id, 
        assigned_userid: props.assigned_userid, 
        appointment_at: props.appointment_at, 
        content: props.content,
        type: props.type_id,
        group: props.technic_group_id,
      }
     
      this.update = this.update + 1
      this.$parent.$bvModal.show('setup')
    },
    arizaDetay(props){
      this.techDetail = props
      this.$parent.$bvModal.show('tech_detail')
    },
    islemeAl(props){
      const { id, subscription_id,username, password, static_ip, type_id, mac } = props
      this.transactionData = { subs_id:subscription_id, id,username, password, static_ip , type_id, mac}
      this.$parent.$bvModal.show('transaction')
    },
    buttonVisible(button,row){
      if(button.visible.includes(row.type_id)){
        if(row.assigned_userid && button.title == 'Personele Ata'){
          return false
        }
       
        return true
      }
     },
    sil(props){
      Vue.swal({
          title: "Silinecek?",
          showCancelButton: true,
          cancelButtonText: "İptal",
          confirmButtonText: "Sil"
      }).then((result) => {
          if (result.value) {
            this.$http.delete('/technic-service/' + props.id)
            .then(response => {
                if(response.data.code == 100){
                  return notify.success(response.data.message)
                }
                return notify.error(response.data.message)
            })
          }
      });

    },
    konumGetir(props){
      this.kurulumDetay = { id:props.subscription_id, action:'read' }
      this.kurulumModalOpen = Math.floor(Math.random() * 1000); 
      this.$parent.$bvModal.show('kurulum_modal')
    },

    mac(){
      this.macModalOpen = this.macModalOpen +1
      this.$parent.$bvModal.show('mac_modal')
    },
  },
};
</script>

<template>
  <Layout> 
    <PageHeader :title="title"  :items="items" />

    <CreateSetup  
      :update="update" 
      :id="data.id"
      :assigned_userid="data.assigned_userid"
      :appointment_at="data.appointment_at"
      :group="data.group"
      :content="data.content"
      :type="data.type"
      @loadItems="loadItems"
    />

     <KurulumModal 
      :data="kurulumDetay" 
      :modelOpen="kurulumModalOpen" 
    />

    <Transaction 
      :transactionData="transactionData"  
      @loadItems="loadItems" />

    <TechDetay 
      :data="techDetail" 
    />
    
    <MacModal 
      :modelOpen="macModalOpen"
    />
    <!--<div class="row mb-3">
      <div class="col-md-12">
        <button class="btn btn-primary">
          M.A.C Sorgula
        </button>
      </div>
    </div>-->
    <Loader :loading="true" :load="dataLoading">
      <div class="row"  v-if="userdata.currentUser.role_name != 'tech'">
        <div class="col-md-3">
          <label>Randevu Tarihi İle Ara</label>
          <div class="input-group mb-3">
            <b-form-input
              v-model="form.appointment_at"
              id="appointment_at"
              @change="filter()"
              type="datetime-local"
              :min="dnow"
            ></b-form-input>
            <button class="btn btn-outline-secondary" type="button" @click="today">Bugun</button>
            <button class="btn btn-outline-secondary" type="button" @click="tomorrow">Yarın</button>
            <button class="btn btn-outline-secondary" type="button" @click="nextday" >Sonraki Gün</button>
          </div>
        </div>
        <div class="col-md-3">
          <label>Randevuyu Oluşturan</label>
          <v-select 
              v-model="form.user_id"
              :options="userList"
              :reduce="form => form.id"
              @input="filter('user_id', $event)"
              label="name">
            <span slot="no-options">Sonuç Bulunamadı</span>
          </v-select>
        </div>
        <div class="col-md-3">
          <label>Atanan</label>
          <v-select 
              v-model="form.assigned_userid"
              :options="personelList"
              :reduce="form => form.id"
              @input="filter('assigned_userid', $event)"
              label="name">
            <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
        </div>
        <div class="col-md-3">
          <label>Bölge</label>
            <v-select 
              v-model="form.quarter_id"
              :options="ilceList"
              :reduce="form => form.id"
              @input="filter('quarter_id', $event)"
              label="name">
            <span slot="no-options">Sonuç Bulunamadı</span>
            </v-select>
        </div>
      </div>
      <template v-if="userdata.currentUser.role_name == 'tech'">
        <div class="row mb-3">
          <div class="col-md-12">
              <button class="btn btn-outline-info" @click="mac()">M.A.C. Adresi Sorgula</button> 
          </div>
        </div>
        <div class="row mb-3" v-if="rows.length == 0">
          <div class="col-md-12">
            <div class="alert bg-light" style="border-left:solid 3px red">İş Emri Bulunmamaktadır.</div>
          </div>
        </div>
        <div class="row mb-3" v-for="(row,i) in rows" :key="i">
          <div class="col-md-12" @click="openTab = i" >
            <div class="accordion" :id="`accordionExample${i}`">
              <div class="accordion-item">
                <h2 class="accordion-header" :id="`heading${i}`" >
                  <button class="accordion-button " style="padding: 10px 20px;" :class="{ collapsed:openTab != i }"  type="button" data-bs-toggle="collapse" :data-bs-target="`#collapseOne${i}`" aria-expanded="true" :aria-controls="`collapseOne${i}`" v-html="type(row.type_id)"></button>
                </h2>
                <div class="accordion-body">
                   <div class="row" v-if="row.type_id==3">
                      <div class="col-md-12">
                        Tanım: <strong>{{ row.subject }}</strong>
                      </div>
                  </div>
                  <div class="row" v-if="row.type_id==3">
                      <div class="col-md-12">
                        Açıklama: <strong>{{ row.content }}</strong>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-12">
                        İsim Soyisim: <strong>{{ row.fullname }}</strong>
                      </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      Telefon: <strong>{{ row.phonenumber }}</strong>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      Adres: <strong>{{ row.address }}</strong> <strong>{{ row.district_name }} / {{ row.quarter_name }}</strong>
                    </div>
                  </div>
                  <div class="row" v-if="row.type_id==5">
                    <div class="col-md-12">
                      Yeni Kurulacak Adres: <strong>{{ row.newaddress }}</strong> <strong>{{ row.newdistrict_name }} / {{ row.newquarter_name }}</strong>
                    </div>
                  </div>
                </div>
                <div :id="`collapseOne${i}`" class="accordion-collapse collapse" :class="{ show:openTab == i }" :aria-labelledby="`heading${i}`" :data-bs-parent="`#accordionExample${i}`">
                  <div class="accordion-body">
                    <div class="row mb-2" v-if="row.type_id!=1">   
                        <div class="d-grid">
                          <button class="btn btn-block btn-outline-primary" @click="konumGetir(row)">Konumu Görüntüle</button>
                        </div>
                    </div>
                    <div class="row mb-2" v-if="row.type_id!=1">
                        <div class="d-grid">
                          <button class="btn btn-block btn-outline-info">Kurulum Resimleri Görüntüle</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="d-grid">
                          <button class="btn btn-block btn-outline-success" @click="islemeAl(row)">İşleme Al</button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="row" v-else>
          <div class="col-md-12">
            <vue-good-table
                mode="remote"
                styleClass="vgt-table bordered condensed"
                :line-numbers="true" 
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                <div>Yükleniyor</div>
                </template>
                    <template
                    slot="table-row"
                    slot-scope="props"
                    >
                    <span
                        v-if="props.column.field === '#'"
                        class="text-nowrap"
                    >
                      <b-dropdown
                        class="ms-2 "
                        toggle-class="font-size-16 p-0"
                        toggle-tag="a"
                        variant="white"
                        right
                      >
                          <template #button-content>
                            <i class="mdi mdi-dots-horizontal"></i>
                          </template>
                          <template   
                          v-for="(button,i) in buttons" >
                          <b-dropdown-item 
                            :key="i" 
                            v-if="buttonVisible(button,props.row)"
                            @click="button.func(props.row)">
                            <i class="bx" :class="`bx-${button.icon}`"></i> {{ button.title }}
                          </b-dropdown-item>
                          </template>
                      </b-dropdown>
                    </span>
                </template>
            </vue-good-table>
        </div>
      </div>
    </Loader>
  </Layout>
</template>